export const serviceData = {
  Name: 'GuidedJourneyJSON',
  Enable: true,
  Items: [
    {
      "SRType": "Membership||New Membership",
      "serviceNameForList": "SR_MEMBERSHIP_REG",
      "id": "membership-registration",
      "sequence": 39,
      "serviceName": "New Membership",
      "serviceNameKey": "MEMBERSHIP_NEW",
      "organization": "Membership",
      "parentServiceKey": "MEMBERSHIP",
      "accessFlagKey": "DC Membership Services Flag",
      "PreText": "By becoming a member, you will access a wide range of exclusive benefits, including easy registration, business growth support, networking opportunities, and expert guidance. Mainland and free zone companies engaged in commercial, industrial, or professional activities can register to become members.",
      "serviceDetail": {
        "description": "By becoming a member, you will access a wide range of exclusive benefits, including easy registration, business growth support, networking opportunities, and expert guidance. Mainland and free zone companies engaged in commercial, industrial, or professional activities can register to become members.",
        "processingTime": "Two hours",
        "feesNote": "AED 300 to AED 2,200"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal. Alternatively, tap access the service on the mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Follow the instructions to submit all your required documents."
        },
        {
          "title": "Approval process",
          "description": "Your application will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and certificate issuance",
          "description": "After paying the fees, you will be prompted to download your unique membership certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Mainland and free zone companies engaged in commercial, industrial, or professional activities can register to become members."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements for different types of business establishments:",
        "list": [
          {
            "title": "Sole proprietorship",
            "description": "Valid trade licence; copy of the licence holder’s or attorney’s passport or Emirates ID; and a copy of the duly attested power of attorney, where applicable.",
            "documents": [{
              "title": "Valid trade licence",
            },
            {
              "title": "copy of the licence holder’s or attorney’s passport or Emirates ID",
            }, {
              "title": "Copy of the duly attested power of attorney, where applicable"
            }]
          },
          {
            "title": "Local companies",
            "description": "Valid trade licence;",
            "documents": [{
              "title": "Valid trade licence",
            },
            {
              "title": " passport or Emirates ID copies of partners, managers or authorised attorney",
            }, {
              "title": " notarised and attested memorandum of association"
            },
            { "title": "a duly attested power of attorney" }
            ]
          },
          {
            "title": "Foreign companies and representative offices",
            "description": "",
            "documents": [{
              "title": "Valid trade licence",
            },
            {
              "title": "Passport or Emirates ID copy of the manager or appointed attorney",
            }, {
              "title": "Notarised and attested memorandum of association of the mother company"
            },
            { "title": "Duly attested Power of Attorney for the manager or attorney" }
            ]
          },
          {
            "title": "Free zone companies and establishments",
            "description": "",
            "documents": [{
              "title": "Valid trade license copy",
            },
            {
              "title": "Passport or Emirates ID copy of the manager or appointed attorney",
            }, {
              "title": "Duly attested memorandum of association/share certificate/certificate of formation"
            },
            { "title": "Letter of authorisation by the manager for the attorney (if appointed)" }
            ]
          }
        ]
      },
      "serviceFees": [
        {
          "title": "The annual fees are determined based on the legal form, nationality of owners, or type of activity of the establishment/company. These fees are categorised as follows:",
          "list": [
            "National establishments (practising specific activity): AED 700",
            "General trading: AED 1,200 - AED 2,200",
            "Banks, insurance companies, building contractors, branches of international foreign companies: AED 2,200",
            "Free zone companies: AED 2,200",
            "Hotels, related financial services and insurance brokers: AED 2,000 - 2,200",
            "Lawyers, auditors and consultancy engineers: AED 1,000 - AED 2,200",
            "Various simple trade: AED 500",
            "Handicraft, e-traders and Intelaq licence: AED 300",
            "Simple handicrafts: AED 50.",
            "Branches holding principal’s trade name: AED 100 - AED 2,200 (according to activity).",
            "5-year exemption for members of the Mohammed Bin Rashid Establishment for Small and Medium Enterprises",
            "*The total service fee amount may vary depending on your specific requirements."
          ]
        }
      ],
      "resources": [
        {
          "title": "Start Service – New Membership",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – Membership Renewal",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – Membership Cancellation",
          "url": "https://dcdigitalservices.dubaichamber.com"
        }
      ]
    },
    {
      "SRType": "Membership||Cancellation",
      "serviceNameForList": "SR_MEMBERSHIP_CANCELLATION",
      "id": "membership-cancellation",
      "sequence": 21,
      "serviceName": "Membership Cancellation",
      "serviceNameKey": "MEMBERSHIP_CANCELLATION",
      "organization": "Membership",
      "parentServiceKey": "MEMBERSHIP",
      "accessFlagKey": "DC Membership Services Flag",
      "PreText": "To cancel Membership",
      "serviceDetail": {
        "description": "If your company is facing liquidation or dissolution, you may need to cancel your Dubai Chamber of Commerce membership. By cancelling your membership, you will discontinue access to all exclusive benefits, including easy registration, business growth support, networking opportunities, and expert guidance.",
        "processingTime": "Two hours",
        "feesNote": "No fees applicable"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal. Alternatively, tap access the service on the mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Submit the application and required documentation through the website/mobile application."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Confirmation",
          "description": "You will receive a confirmation that your membership has been cancelled."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Members who are already registered can cancel their memberships."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements for different types of business establishments:",
        "list": [
          {
            "title": "Free zone",
            "description": "",
            "documents": [{
              "title": "Request letter from the company signed by the authorised person."
            }]
          },
          {
            "title": "Mainland",
            "description": "",
            "documents": [{
              "title": "Cancellation letter from DET."
            }]
          }
        ]
      },
      "serviceFees": [
        {
          "title": "No fees applicable",
          "list": [
          ]
        }
      ],

      "resources": [
        {
          "title": "Certificate of Origin Membership",
          "url": "https://www.dubaichambers.com/en"
        },
        {
          "title": "FAQs",
          "url": "https://www.dubaichambers.com/en"
        },
        {
          "title": "Service Manual",
          "url": "https://www.dubaichambers.com/en"
        }
      ]
    },
    {
      "SRType": "Membership||Renew Membership",
      "serviceNameForList": "SR_MEMBERSHIP_RENEW",
      "id": "membership-renewal",
      "sequence": 19,
      "serviceName": "Membership Renewal",
      "serviceNameKey": "MEMBERSHIP_RENEW",
      "organization": "Membership",
      "parentServiceKey": "MEMBERSHIP",
      "accessFlagKey": "DC Membership Services Flag",
      "PreText": "Annual renewal of Membership",
      "serviceDetail": {
        "description": "By becoming a member, you will access a wide range of exclusive benefits, including easy registration, business growth support, networking opportunities, and expert guidance. Mainland and free zone companies engaged in commercial, industrial, or professional activities can register to become members.",
        "processingTime": "Two hours",
        "feesNote": "AED 300 - AED 2,200"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal. Alternatively, tap access the service on the mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Follow the instructions to submit all your required documents."
        },
        {
          "title": "Approval process",
          "description": "Your application will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and certificate issuance",
          "description": "After paying the fees, you will be prompted to download your unique membership certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Mainland and free zone companies engaged in commercial, industrial, or professional activities can register to become members."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements for different types of business establishments:",
        "list": [
          {
            "title": "Sole proprietorship",
            "description": "Valid trade licence; copy of the licence holder’s or attorney’s passport or Emirates ID; and a copy of the duly attested power of attorney, where applicable.",
            "documents": [{
              "title": "Valid trade licence",
            },
            {
              "title": "copy of the licence holder’s or attorney’s passport or Emirates ID",
            }, {
              "title": "Copy of the duly attested power of attorney, where applicable"
            }]
          },
          {
            "title": "Local companies",
            "description": "Valid trade licence;",
            "documents": [{
              "title": "Valid trade licence",
            },
            {
              "title": " passport or Emirates ID copies of partners, managers or authorised attorney",
            }, {
              "title": " notarised and attested memorandum of association"
            },
            { "title": "a duly attested power of attorney" }
            ]
          },
          {
            "title": "Foreign companies and representative offices",
            "description": "",
            "documents": [{
              "title": "Valid trade licence",
            },
            {
              "title": "Passport or Emirates ID copy of the manager or appointed attorney",
            }, {
              "title": "Notarised and attested memorandum of association of the mother company"
            },
            { "title": "Duly attested Power of Attorney for the manager or attorney" }
            ]
          },
          {
            "title": "Free zone companies and establishments",
            "description": "",
            "documents": [{
              "title": "Valid trade license copy",
            },
            {
              "title": "Passport or Emirates ID copy of the manager or appointed attorney",
            }, {
              "title": "Duly attested memorandum of association/share certificate/certificate of formation"
            },
            { "title": "Letter of authorisation by the manager for the attorney (if appointed)" }
            ]
          }
        ]
      },
      "serviceFees": [
        {
          "title": "The annual fees are determined based on the legal form, nationality of owners, or type of activity of the establishment/company. These fees are categorised as follows:",
          "list": [
            "National establishments (practising specific activity): AED 700",
            "General trading: AED 1,200 - AED 2,200",
            "Banks, insurance companies, building contractors, branches of international foreign companies: AED 2,200",
            "Free zone companies: AED 2,200",
            "Hotels, related financial services and insurance brokers: AED 2,000 - 2,200",
            "Lawyers, auditors and consultancy engineers: AED 1,000 - AED 2,200",
            "Various simple trade: AED 500",
            "Handicraft, e-traders and Intelaq licence: AED 300",
            "Simple handicrafts: AED 50.",
            "Branches holding principal’s trade name: AED 100 - AED 2,200 (according to activity).",
            "5-year exemption for members of the Mohammed Bin Rashid Establishment for Small and Medium Enterprises",
            "*The total service fee amount may vary depending on your specific requirements."
          ]
        }
      ],
      "resources": [
        {
          "title": "Start Service – Membership Renewal",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – New Membership",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – Membership Amendment",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – Membership Cancellation",
          "url": "https://dcdigitalservices.dubaichamber.com"
        }
      ],

    },
    {
      "SRType": "Membership||Amendment Membership",
      "serviceNameForList": "SR_MEMBERSHIP_AMD",
      "id": "membership-amendment",
      "sequence": 18,
      "serviceName": "Membership Amendment",
      "serviceNameKey": "MEMBERSHIP_AMENDMENT",
      "organization": "Membership",
      "parentServiceKey": "MEMBERSHIP",
      "accessFlagKey": "DC Membership Services Flag",
      "PreText": "Modify / amend details of Membership",
      "serviceDetail": {
        "description": "Keep your membership profile updated to maintain access to a wide range of exclusive benefits, including easy registration, business growth support, networking opportunities, and expert guidance.",
        "processingTime": "Two hours",
        "feesNote": "AED 100"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal. Alternatively, tap access the service on the mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Follow the instructions to submit all your required documents."
        },
        {
          "title": "Approval process",
          "description": "Your application will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and certificate issuance",
          "description": "After paying the fees, you will be prompted to download your unique membership certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Members who are already registered can update and amend their memberships."
        }
      ],
      "serviceRequirements": {
        "title": "To update or amend your membership, please submit a copy of the modified document (e.g., memorandum of association, Partner/Manager Emirates ID, or passport copy).",
        "list": [
          {
            "title": "Documents",
            "description": "",
            "documents": [{
              "title": "Memorandum of association",
            },
            {
              "title": "Partner/Manager Emirates ID, or passport copy"
            }]
          }
        ]
      },
      "serviceFees": [
        {
          "title": "Membership amendment fees: AED 100",
          "list": []
        }
      ],
      "resources": [
        {
          "title": "Start Service – Membership Amendment",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – New Membership",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – Membership Renewal",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – Membership Cancellation",
          "url": "https://dcdigitalservices.dubaichamber.com"
        }
      ]

    },
    {
      "SRType": "Membership||Manage Signatories",
      "serviceNameForList": "SR_MEMBERSHIP_MANAGE_SIGNATORIES",
      "id": "membership-manage-signatories",
      "sequence": 20,
      "serviceName": "Manage Signatories",
      "serviceNameKey": "MEMBERSHIP_MANAGEMENT_SIGNATORIES",
      "organization": "Membership",
      "parentServiceKey": "MEMBERSHIP",
      "accessFlagKey": "DC Membership Services Flag",
      "PreText": "You can add/remove only the current signatories. To add new signatories please go to amend membership service.",
      "serviceDetail": {
        "description": "You can add/remove only the current signatories. To add new signatories please go to amend membership service.",
        "processingTime": "Two hours",
        "feesNote": "No fees applicable"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal. Alternatively, tap access the service on the mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Follow the instructions to submit all your required documents."
        },
        {
          "title": "Approval process",
          "description": "Your application will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Certificate issuance",
          "description": "After approve, you will be able to download your membership certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Members who are already registered can update and amend their memberships."
        }
      ],
      "serviceRequirements": {
        "title": "Kindly make sure of the availability of below pre-requisites to avail the service.",
        "list": [
          {
            "title": "Add new signatories (Document List)",
            "description": "",
            "documents": [{
              "title": "Signature Card / Emirates ID Copy",
            },
            {
              "title": "Power of Attorney issued from Notary public for (Required for Non FreeZone License)."
            }, {
              "title": "License Copy"
            },
            {
              "title": "MOA/Share Certificate/Certificate of Formation/Article of Association."
            }, {
              "title": "Either Passport Copy or Emirates ID"
            }, {
              "title": "Authorization letter on company letterhead, stamped & signed by authorized signatory for (Required for Free Zone License)"
            }]
          },
          {
            "title": "Remove Signatories (Document List)",
            "description": "",
            "documents": [{
              "title": "Request letter from Authorized person for removal of Signatory (Required incase of removing existing signatory)",
            }, {
              "title": "Amended MOA (Required for Non FreeZone License)",
            }]
          }
        ]
      },
      "serviceFees": [
        {
          "title": "Fees not applicable",
          "list": []
        }
      ],
      "resources": [
        {
          "title": "Start Service – Membership Amendment",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – New Membership",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – Membership Renewal",
          "url": "https://dcdigitalservices.dubaichamber.com"
        },
        {
          "title": "Related Service – Membership Cancellation",
          "url": "https://dcdigitalservices.dubaichamber.com"
        }
      ]

    },

    {
      SRType: 'Certificate Of Origin||Issue New COO',
      "serviceNameForList": "SR_ISSUE_COO",
      id: 'coo',
      sequence: 1,
      "PreText": "This service allows you to apply for a Certificate of Origin, an official document that determines the origin of exported and re-exporting of goods. It determines customs tariffs and must be accompanied by a detailed commercial invoice. Obtaining this certificate ensures compliance with customs regulations.",
      "serviceName": "Issuing a Certificate of Origin",
      "serviceNameKey": "ISSUE_NEW_COO",
      "organization": "Certificate Of Origin",
      "parentServiceKey": "COO",
      "accessFlagKey": "DC COO Services Flag",
      "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin",
      "serviceDetail": {
        "description": "This service allows you to apply for a Certificate of Origin, an official document that determines the origin of exported and re-exporting of goods. It determines customs tariffs and must be accompanied by a detailed commercial invoice. Obtaining this certificate ensures compliance with customs regulations.",
        "processingTime": "Two hours",
        "feesNote": "AED 100"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to sign in or register on the Dubai Chambers services portal, or open the service from the Dubai Chambers mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Complete the online form and upload all required documents relating to the shipment."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements for issuing a Certificate of Origin:",
        "list": [
          {
            "title": "Primary document",
            "description": "Direct shipment",
            "documents": [{
              "title": "Invoice"
            }, {
              "title": "Bill of Lading"
            }
            ]
          },
          {
            "title": "UAE origin",
            "description": "Bill of lading when the shipment is sent directly to the destination country.",
            "documents": [{
              "title": "Copy of the industrial license",
            }, {
              "title": "Copy of the factory’s invoice",
            }
            ]
          },
          {
            "title": "Transshipment goods",
            "description": "Copy of bill transit from Dubai Customs",
            "documents": [{
              "title": "Copy of bill transit from Dubai Customs",
            }]
          },
          {
            "title": "Please be aware that Dubai Chambers reserves the right to request any additional supporting documents if necessary, including:",
            "description": "Copy of bill transit from Dubai Customs",
            "documents": [{
              "title": "Packing list",
            }, {
              "title": "Bills of the exporting country ",
            }, {
              "title": "Exporter’s country invoice",
            }]
          }
        ]
      },
      "serviceFees": [
        {
          "title": "Service fees",
          "list": [
            "Issuing a Certificate of Origin: AED 100.",
            "AED 5 for each additional page after page 5 of the commercial invoice.",
            "AED 5 for each page of the packing list."
          ]
        }
      ],
      "additionalInformation": {
        "otherChannels": "You can also apply through the Dubai Chambers mobile app by logging in, selecting the Certificate of Origin service and submitting your application from your device.",
        "contact": "WhatsApp: (+971) 800 242 6237; toll-free within UAE: 800 242 6237 (800 CHAMBER); international: (+971) 4 228 0000. 24/7 chat support and an enquiry email are available via the Dubai Chambers website.",
        "location": "Service is delivered online through the Dubai Chambers services portal and mobile app, with additional assistance available via Dubai Chambers customer happiness and contact channels."
      },
      "howToApply": [
        "Open the Issuing a Certificate of Origin service page on the Dubai Chambers website and click \"Start Service\".",
        "Sign in or create an account, fill in the shipment details and upload the required documents.",
        "Submit the application, pay the fees and download the Certificate of Origin once it has been approved."
      ],
      "resources": [
        {
          "title": "Issuing a Certificate of Origin Service Page",
          "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin"
        },
        {
          "title": "Amendment of Certificate of Origin Service Page",
          "url": "https://www.dubaichambers.com/en/amendment-of-certificate-of-origin"
        },
        {
          "title": "Generalised System of Preferences (GSP) Service Page",
          "url": "https://www.dubaichambers.com/en/generalised-system-of-preferences"
        }
      ],

    },
    {
      SRType: 'Certificate Of Origin||Amendment',
      "serviceNameForList": "SR_AMD_COO",
      id: 'coo-amendment',
      sequence: 4,
      PreText: 'Modify / amend issued Certificate of Origin',
      "serviceName": "Amendment of Certificate of Origin",
      "serviceNameKey": "AMENDMENT_COO",
      "organization": "Certificate Of Origin",
      "parentServiceKey": "COO",
      "accessFlagKey": "DC COO Services Flag",
      "url": "https://www.dubaichambers.com/en/amendment-of-certificate-of-origin",
      "serviceDetail": {
        "description": "This service allows you to amend an existing Certificate of Origin, an essential document for exporting goods. By updating your certificate, you maintain compliance with customs regulations and ensure the accuracy of your trade documentation, which must be accompanied by a detailed commercial invoice.",
        "processingTime": "Two hours",
        "feesNote": "AED 50"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to sign in or register on the Dubai Chambers services portal, or open the service from the Dubai Chambers mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Complete the online form and upload all required documents relating to the shipment."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements to apply for this service:",
        "list": [
          {
            "title": "Primary document",
            "description": "Direct shipment",
            "documents": [{
              "title": "The modified commercial invoice, or any document that has been modified."
            }]
          }
        ]
      },
      "serviceFees": [
        {
          "title": "Service fees",
          "list": [
            "Issuing a Certificate of Origin: AED 100.",
            "AED 5 for each additional page after page 5 of the commercial invoice.",
            "AED 5 for each page of the packing list."
          ]
        }
      ],

      "resources": [
        {
          "title": "Amendment of Certificate of Origin Service Page",
          "url": "https://www.dubaichambers.com/en/amendment-of-certificate-of-origin"
        },
        {
          "title": "Issuing a Certificate of Origin Service Page",
          "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin"
        },
        {
          "title": "Issuing a Certificate of Origin for Personal Effect Service Page",
          "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin-for-personal-effect"
        }
      ]
    },
    {
      "SRType": "Certificate Of Origin||Personal Effects",
      "serviceNameForList": "SR_PERSONAL_COO",
      "id": "coo-personal-effect",
      "sequence": 6,
      "PreText": "Request to issue Certificate of Origin to move your personal goods to home country",
      "serviceName": "Issuing a Certificate of Origin for Personal Effect",
      "serviceNameKey": "PERSONAL_EFFECTS_COO",
      "organization": "Certificate Of Origin",
      "parentServiceKey": "COO",
      "accessFlagKey": "DC COO Services Flag",
      "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin-for-personal-effect",
      "serviceDetail": {
        "description": "This service allows you to apply for a Certificate of Origin for personal effects, an essential document that determines the origin of your personal effects for exporting. By obtaining this certificate, you ensure compliance with customs regulations, making your international shipping process smooth and hassle-free.",
        "processingTime": "Two hours",
        "feesNote": "AED 100"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to sign in or register on the Dubai Chambers services portal, or open the service from the Dubai Chambers mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Follow the instructions to submit all your required documents."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        }, {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Individuals can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements to apply for this service:",
        "list": [
          {
            "title": "Used personal effect form",
            "documents": []
          },
          {
            "title": "A valid passport or Emirates ID copy",
            "documents": []
          }
        ]
      },
      "serviceFees": [
        {
          "title": "Service fees",
          "list": [
            "AED 100.",
            "Note: A fee of AED 5 will be charged for each additional page after page 5 of the form."
          ]
        }
      ],
      "resources": [
        {
          "title": "Issuing a Certificate of Origin for Personal Effect Service Page",
          "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin-for-personal-effect"
        },
        {
          "title": "Issuing a Certificate of Origin Service Page",
          "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin"
        },
        {
          "title": "Generalised System of Preferences (GSP) Service Page",
          "url": "https://www.dubaichambers.com/en/generalised-system-of-preferences"
        }
      ]
    },
    {
      "SRType": "Certificate Of Origin||Issue GSP Certificate",
      "serviceNameForList": "SR_ISSUE_GSP_CERTIFICATE",
      "id": "issue-gsp-certificate",
      "sequence": 2,
      "serviceName": "Generalised System of Preferences (GSP)",
      "serviceNameKey": "ISSUE_GSP_COO",
      "PreText": "GSP Certificate of origin is issued to the exporters of developing countries to get the tariff preferences in developed countries.",
      "organization": "Certificate Of Origin",
      "parentServiceKey": "COO",
      "accessFlagKey": "DC COO Services Flag",
      "url": "https://www.dubaichambers.com/en/generalised-system-of-preferences",
      "serviceDetail": {
        "description": "By becoming a member, you will access a wide range of exclusive benefits, including easy registration, business growth support, networking opportunities, and expert guidance. Mainland and free zone companies engaged in commercial, industrial, or professional activities can register to become members.",
        "processingTime": "Two hours",
        "feesNote": "AED 100"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to sign in or register on the Dubai Chambers services portal, or open the service from the Dubai Chambers mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Complete the online form and upload all required documents relating to the shipment."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Your exported shipment should meet the following criteria to avail the GSP service::",
        "list": [
          {
            "title": "Product Origin:",
            "documents": [{
              "title": "Product should be a UAE-origin Product."
            }]
          },
          {
            "title": "Destination Country:",
            "documents": [{
              "title": "Your shipment should be exported to one of the listed countries in the application."
            }]
          },
          {
            "title": "Documentation:",
            "description": "",
            "documents": [{
              "title": "If you hold an Industrial license, a copy of the commercial invoice is required."
            }, {
              "title": "If you hold a Commercial license, a copy of the commercial invoice and a copy of purchase invoice from UAE-based factory are required."
            }]
          }
        ]
      },
      "serviceFees": [
        {
          "title": "Service fees",
          "list": [
            "AED 100."
          ]
        }
      ],

      "resources": [
        {
          "title": "Generalised System of Preferences (GSP) Service Page",
          "url": "https://www.dubaichambers.com/en/generalised-system-of-preferences"
        },
        {
          "title": "Issuing a Certificate of Origin Service Page",
          "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin"
        },
        {
          "title": "Issuing a Certificate of Origin for Personal Effect Service Page",
          "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin-for-personal-effect"
        }
      ]

    },
    {
      SRType: 'Certificate Of Origin||COO Bulk Upload',
      "serviceNameForList": "SR_COO_BULK_UPLOAD",
      id: 'coo-bulk-upload',
      sequence: 1,
      "PreText": "This service allows users to upload a COO bulk template and create multiple Certificate of Origin requests in draft status.",
      "serviceName": "COO Bulk Upload",
      "serviceNameKey": "COO_BULK_UPLOAD",
      "organization": "Certificate Of Origin",
      "parentServiceKey": "COO",
      "accessFlagKey": "DC COO Services Flag",
      "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin",
      "serviceDetail": {
        "description": "This service allows users to upload a COO bulk template and create multiple Certificate of Origin requests in draft status. Users can then upload the required supporting documents for each service request individually and submit them for review. The Certificate of Origin is an official document that certifies the origin of exported or re-exported goods and supports compliance with customs regulations and tariff requirements.",
        "processingTime": "Two hours",
        "feesNote": "AED 100"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to sign in or register on the Dubai Chambers services portal, or open the service from the Dubai Chambers mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Complete the online form and upload all required documents relating to the shipment."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements for issuing a Certificate of Origin:",
        "list": [
          {
            "title": "Primary document",
            "description": "Direct shipment",
            "documents": [{
              "title": "Invoice"
            }, {
              "title": "Bill of Lading"
            }
            ]
          },
          {
            "title": "UAE origin",
            "description": "Bill of lading when the shipment is sent directly to the destination country.",
            "documents": [{
              "title": "Copy of the industrial license",
            }, {
              "title": "Copy of the factory’s invoice",
            }
            ]
          },
          {
            "title": "Transshipment goods",
            "description": "Copy of bill transit from Dubai Customs",
            "documents": [{
              "title": "Copy of bill transit from Dubai Customs",
            }]
          },
          {
            "title": "Please be aware that Dubai Chambers reserves the right to request any additional supporting documents if necessary, including:",
            "description": "Copy of bill transit from Dubai Customs",
            "documents": [{
              "title": "Packing list",
            }, {
              "title": "Bills of the exporting country ",
            }, {
              "title": "Exporter’s country invoice",
            }]
          }
        ]
      },
      "serviceFees": [
        {
          "title": "Service fees",
          "list": [
            "Issuing a Certificate of Origin: AED 100.",
            "AED 5 for each additional page after page 5 of the commercial invoice.",
            "AED 5 for each page of the packing list."
          ]
        }
      ],
      "additionalInformation": {
        "otherChannels": "You can also apply through the Dubai Chambers mobile app by logging in, selecting the Certificate of Origin service and submitting your application from your device.",
        "contact": "WhatsApp: (+971) 800 242 6237; toll-free within UAE: 800 242 6237 (800 CHAMBER); international: (+971) 4 228 0000. 24/7 chat support and an enquiry email are available via the Dubai Chambers website.",
        "location": "Service is delivered online through the Dubai Chambers services portal and mobile app, with additional assistance available via Dubai Chambers customer happiness and contact channels."
      },
      "howToApply": [
        "Open the Issuing a Certificate of Origin service page on the Dubai Chambers website and click \"Start Service\".",
        "Sign in or create an account, fill in the shipment details and upload the required documents.",
        "Submit the application, pay the fees and download the Certificate of Origin once it has been approved."
      ],
      "resources": [
        {
          "title": "Issuing a Certificate of Origin Service Page",
          "url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin"
        },
        {
          "title": "Amendment of Certificate of Origin Service Page",
          "url": "https://www.dubaichambers.com/en/amendment-of-certificate-of-origin"
        },
        {
          "title": "Generalised System of Preferences (GSP) Service Page",
          "url": "https://www.dubaichambers.com/en/generalised-system-of-preferences"
        }
      ],

    },
    {
      "SRType": "Attestation||Authenticate Certificate",
      "id": "attestation-authenticate-document",
      "serviceNameForList": "SR_AUTHENTICATE_DOCUMENT",
      "sequence": 15,
      "PreText": "Request to authenticate Certificates and Documents issued by entities under Dubai Government and the letterhead possess Dubai government logo",
      "serviceName": "Authentication",
      "serviceNameKey": "ATTESTATION_AUTH_CERTIFICATE",
      "organization": "Attestation",
      "parentServiceKey": "ATTESTATION",
      "accessFlagKey": "DC SVS Services Flag",
      "serviceDetail": {
        "description": "Authenticate your Government-related documents to ensure they are officially recognised. This service streamlines processes and enhances the acceptance and credibility of essential documents for our members.",
        "processingTime": "Two hours",
        "feesNote": "AED 100"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to sign up or log in to the Dubai Chambers services portal, or open the service from the Dubai Chambers mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Follow the instructions to submit all your required documents."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements to apply for this service:",
        "list": [
          {
            "title": "The document requiring attestation (attested from the issuing authority/entity)",
          }
        ],
        "note": "Please be aware that Dubai Chambers reserves the right to request any additional supporting documents if necessary."
      },
      "serviceFees": [
        {
          "title": "Authentication fees",
          "list": [
            "Minimum: AED 100.",
          ],
          "note": "Note: A fee of AED 10 will be charged for each additional copy after the 5th copy of the same transaction."
        }
      ],
      "resources": [
        {
          "title": "Authentication Service Page",
          "url": "https://www.dubaichambers.com/en/authentication"
        },
        {
          "title": "True Copy Service Page",
          "url": "https://www.dubaichambers.com/en/true-copy"
        },
        {
          "title": "Signature Attestation Service Page",
          "url": "https://www.dubaichambers.com/en/signature-attestation"
        }
      ]

    },
    {
      "SRType": "Attestation||True Copy",
      "serviceNameForList": "SR_CERTIFY_DOCUMENT",
      "id": "attestation-certify-document",
      "sequence": 16,
      "serviceName": "True Copy",
      "serviceNameKey": "ATTESTATION_CERTIFY_DOCUMENT",
      "organization": "Attestation",
      "parentServiceKey": "ATTESTATION",
      "accessFlagKey": "DC SVS Services Flag",
      "PreText": "Request for  verification and attestation of a document as true copy of the original",
      "serviceDetail": {
        "description": "Improve the credibility of your documents to make transactions and communication with official entities easier with our True Copy attestation service. We guarantee that your documents are accurate copies of the originals, ensuring that they are recognised by the relevant authorities.",
        "processingTime": "Two hours",
        "feesNote": "AED 100"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to create an account or log in to the Dubai Chambers services portal, or access the service through the Dubai Chambers mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Upload the document that requires true copy attestation and complete the online request form."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your certificate."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements to apply for this service:",
        "list": [
          {
            "title": "The document requiring attestation (Upload the document under Signature verification Document tag.)",
            "description": ""
          }
        ],
        "note": "Please be aware that Dubai Chambers reserves the right to request any additional supporting documents if necessary."
      },
      "serviceFees": [
        {
          "title": "True Copy fees",
          "list": [
            "Minimum: AED 100"
          ],
          "note": "Note: A fee of AED 10 will be charged for each additional copy after 5 copies of the same transaction."
        }
      ],
      "resources": [
        {
          "title": "True Copy Service Page",
          "url": "https://www.dubaichambers.com/en/true-copy"
        },
        {
          "title": "Authentication Service Page",
          "url": "https://www.dubaichambers.com/en/authentication"
        },
        {
          "title": "Signature Attestation Service Page",
          "url": "https://www.dubaichambers.com/en/signature-attestation"
        }
      ]

    },
    {
      "SRType": "Attestation||Verify Signature",
      "serviceNameForList": "SR_VERIFY_SIGNATURE",
      "id": "attestation-verify-signature",
      "sequence": 17,
      "serviceName": "Signature Verification",
      "serviceNameKey": "ATTESTATION_VERIFY_SIGNATURE",
      "organization": "Attestation",
      "parentServiceKey": "ATTESTATION",
      "accessFlagKey": "DC SVS Services Flag",
      "PreText": "Request for signature verfication of documents",
      "serviceDetail": {
        "description": "Verify and authenticate the authorised signatory and related documents, correspondence, and contracts, ensuring they are accepted by the relevant authorities. This service helps our members by simplifying procedures and enhancing the credibility of their official documents.",
        "processingTime": "Two hours",
        "feesNote": "AED 100"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to sign in or register on the Dubai Chambers services portal, or access the service from the Dubai Chambers mobile app."
        },
        {
          "title": "Submit your application",
          "description": "Follow the instructions to submit all your required documents."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "Once the fees are paid, you can download your signature‑attested document from the portal."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements to apply for this service:",
        "list": [
          {
            "title": "The document requiring attestation should be signed by the authorised signatory",
            "description": ""
          }
        ],
        "note": "Please be aware that Dubai Chambers reserves the right to request any additional supporting documents if necessary."
      },
      "serviceFees": [
        {
          "title": "Signature Verification fees",
          "list": [
            "AED 100",
            "Note: A fee of AED 10 will be charged for each additional copy after the 5th copy of the same transaction."
          ]
        }
      ],

      "resources": [
        {
          "title": "True Copy Service Page",
          "url": "https://www.dubaichambers.com/en/true-copy"
        },
        {
          "title": "Authentication Service Page",
          "url": "https://www.dubaichambers.com/en/authentication"
        },
        {
          "title": "Signature Attestation Service Page",
          "url": "https://www.dubaichambers.com/en/signature-attestation"
        }
      ]

    },

    {
      "SRType": "ATA Carnet||Issue New Carnet",
      "serviceNameForList": "SR_ATA_CARNET_NEW",
      "id": "ata-carnet-registration",
      "sequence": 7,
      "PreText": "Request for new Carnet that will allow the holder to export goods temporarily to single or multiple countries which are part of the Carnet system.",
      "serviceName": "Issuance of ATA Carnet",
      "serviceNameKey": "ISSUE_NEW_CARNET",
      "organization": "ATA Carnet",
      "parentServiceKey": "ATA_CARNET",
      "accessFlagKey": "DC ATA Carnet Flag",
      "serviceDetail": {
        "description": "Apply for an international customs document that allows you to temporarily import/export goods without paying duties or taxes for up to one year. This document simplifies the process of taking your products across borders for trade shows, exhibitions, or other temporary purposes, ensuring hassle-free and cost-effective international business activities.",
        "processingTime": "1-2 business days",
        "feesNote": "AED 900 - AED 2,300"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to log in or create an account on the Dubai Chambers services portal."
        },
        {
          "title": "Submit your application",
          "description": "Fill in the ATA Carnet application form and upload the required documents for the shipment."
        },
        {
          "title": "Approval process",
          "description": "Your application will be reviewed and approved within two business days of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your documents."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members and non-members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements to apply for this service:",
        "list": [
          {
            "title": "Commercial invoice",
            "description": ""
          },
          {
            "title": "Authorisation letter issued by the company to its representatives or agents",
            "description": ""
          },
          {
            "title": "Please be aware that Dubai Chambers reserves the right to request any additional supporting documents if necessary",
            "description": ""
          }
        ]
      },
      "serviceFees": [
        {
          "title": "ATA Carnet processing fee (valid for a single visit)",
          "list": [
            "Member - AED 900",
            "Non-member - AED 1,800"
          ]
        },
        {
          "title": "ATA Carnet Express processing fees (valid for a single country visit)",
          "list": [
            "Member - AED 1,400",
            "Non-member - AED 2,300"
          ]
        },
        {
          "title": "Additional countries",
          "list": [
            "Member - AED 50 for each country",
            "Non-member - AED 100 for each country"
          ]
        },
        {
          "title": "Additional pages for the general list",
          "list": [
            "Member - AED 5 for each country",
            "Non-member - AED 10 for each country"
          ]
        },
        {
          "title": "Regularisation",
          "list": [
            "Member - AED 300",
            "Non-member - AED 600"
          ]
        },
        {
          "title": "Security Deposit",
          "list": [
            "The security deposit fees are based on the total value of goods and customs duties (ATA Carnet Security Rate Chart) in the visiting countries. They will be refunded after the Carnet is properly discharged.",
            "Note: The total service fee amount may vary depending on your specific requirements."
          ]
        },
        {
          "title": "Notes:",
          "list": [
            "Security deposit Calculation = (Total invoice value * Total Tax/100)",
            "If currency is other than AED, Please convert invoice value to AED then proceed with the Calculation.",
            "Final amount of Security deposit will be shared upon submission of service request.",
            "For multiple destinations, the calculation will be based on the country with the highest percentage"
          ]
        }
      ],
      "resources": [
        {
          "title": "Issuance of ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
        },
        {
          "title": "Service Manual – Dubai Chambers Services",
          "url": "https://www.dubaichambercommerce.com/documents/20119/0/Service_Manual_En.pdf"
        }
      ]
    },
    {
      "SRType": "ATA Carnet||Substitute Carnet",
      "serviceNameForList": "SR_ATA_CARNET_SUBS",
      "id": "ata-carnet-substitute",
      "sequence": 10,
      "PreText": "Request to issue duplicate Carnet in case the original Carnet is lost",
      "serviceName": "Substitute of lost ATA Carnet",
      "serviceNameKey": "SUBSTITUTE_CARNET",
      "organization": "ATA Carnet",
      "parentServiceKey": "ATA_CARNET",
      "accessFlagKey": "DC ATA Carnet Flag",
      "serviceDetail": {
        "description": "If your ATA Carnet is lost, damaged, or destroyed, it's important to obtain a Substitute ATA Carnet to continue international business activities without interruption. This document is crucial for entering or exiting foreign countries and re-entering the UAE, allowing temporary import of goods without paying duties or taxes for up to one year.",
        "processingTime": "1 business day",
        "feesNote": " AED 900 - AED 1,800"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to log in or create an account on the Dubai Chambers services portal."
        },
        {
          "title": "Submit your application",
          "description": "Fill in the ATA Carnet application form and upload the required documents for the shipment."
        },
        {
          "title": "Approval process",
          "description": "Your application will be reviewed and approved within two business days of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your documents."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members and non-members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "No document requirements are needed to apply for this service.",
        "list": []
      },
      "serviceFees": [
        {
          "title": "Fees for member and non-member:",
          "list": [
            "Member - AED 900",
            "Non-member - AED 1800"
          ]
        }
      ],
      "resources": [
        {
          "title": "Substitute of lost ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/substitute-of-lost-ata-carnet"
        },
        {
          "title": "Issuance of ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
        }
      ]
    },
    {
      "SRType": "ATA Carnet||Amendment Carnet",
      "serviceNameForList": "SR_ATA_CARNET_AMD",
      "id": 'ata-carnet-amendment',
      "sequence": 8,
      "PreText": "Modify / amend issued Carnet",
      "serviceName": "Modification of ATA Carnet",
      "serviceNameKey": "AMENDMENT_CARNET",
      "organization": "ATA Carnet",
      "parentServiceKey": "ATA_CARNET",
      "accessFlagKey": "DC ATA Carnet Flag",
      "serviceDetail": {
        "description": "Apply for a modified ATA Carnet to temporarily import goods without duties or taxes for up to one year. This simplifies moving products across borders for trade shows, exhibitions, and other temporary purposes. Keep your ATA Carnet current to ensure smooth and cost-effective international business activities.",
        "processingTime": "1 business day",
        "feesNote": "AED 100 - AED 200"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to log in or create an account on the Dubai Chambers services portal."
        },
        {
          "title": "Submit your application",
          "description": "Fill in the ATA Carnet application form and upload the required documents for the shipment."
        },
        {
          "title": "Approval process",
          "description": "Your application will be reviewed and approved within two business days of submission if you meet all the requirements.",
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your documents."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members and non-members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements to apply for this service:",
        "list": [
          {
            "title": "Modified commercial invoice",
            "description": ""
          },
          {
            "title": "Modified authorisation letter issued by the company to its representatives or agents",
            "description": ""
          },
          {
            "title": "Please be aware that Dubai Chambers reserves the right to request any additional supporting documents if necessary",
            "description": ""
          }
        ]
      },
      "serviceFees": [
        {
          "title": "Fees for member and non-member:",
          "list": [
            "Member - AED 100",
            "Non-member - AED 200",
            "Note: Fees might vary based on application details."
          ]
        }
      ],
      "resources": [
        {
          "title": "Modification of ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/modification-of-ata-carnet"
        },
        {
          "title": "Issuance of ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
        }
      ]
    },
    {
      "SRType": "ATA Carnet||Replacement Carnet",
      "serviceNameForList": "SR_ATA_CARNET_REPLACE",
      "id": "ata-carnet-replace",
      "sequence": 11,
      "serviceName": "Replacement of ATA Carnet",
      "serviceNameKey": "REPLACE_CARNET",
      "organization": "ATA Carnet",
      "parentServiceKey": "ATA_CARNET",
      "accessFlagKey": "DC ATA Carnet Flag",
      "PreText": "Request to issue a new Carnet that will replace the original (near expiry) Carnet with new extended carnet valid for another 12 months",
      "serviceDetail": {
        "description": "If your original ATA Carnet is expiring soon and you require more time to temporarily import/export goods without paying duties or taxes, you can apply for a Replacement ATA Carnet. This document simplifies cross-border activities for trade shows, exhibitions, or other temporary purposes, facilitating smooth and cost-effective international business operations.",
        "processingTime": "1 business day",
        "feesNote": " AED 900 - AED 1,800"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to log in or create an account on the Dubai Chambers services portal."
        },
        {
          "title": "Submit your application",
          "description": "Fill in the ATA Carnet application form and upload the required documents for the shipment."
        },
        {
          "title": "Approval process",
          "description": "Your application will be reviewed and approved within two business days of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your documents."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members and non-members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "No document requirements are needed to apply for this service.",
        "list": []
      },
      "serviceFees": [
        {
          "title": "Fees for member and non-member:",
          "list": [
            "Member - AED 900",
            "Non-member - AED 1800"
          ]
        }
      ],
      "resources": [
        {
          "title": "Replacement of ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/replacement-of-ata-carnet"
        },
        {
          "title": "Issuance of ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
        }
      ]
    },
    {
      "SRType": "ATA Carnet||Refund",
      "serviceNameForList": "SR_ATA_CARNET_REFUND",
      "id": "ata-carnet-refund",
      "sequence": 13,
      "serviceName": "Refund of ATA Carnet",
      "serviceNameKey": "REFUND_CARNET",
      "organization": "ATA Carnet",
      "parentServiceKey": "ATA_CARNET",
      "accessFlagKey": "DC ATA Carnet Flag",
      "PreText": "Kindly submit the original Copy of ATA Carnet before submission.",
      "serviceDetail": {
        "description": "It's important to return your ATA Carnet when no longer needed to avoid customs issues and prevent misuse. This ensures compliance with regulations, terminates temporary import privileges, maintains proper documentation, and avoids customs duties or taxes.",
        "processingTime": "1 business day",
        "feesNote": "No refund of processing fees"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to log in or create an account on the Dubai Chambers services portal."
        },
        {
          "title": "Submit your application",
          "description": "Fill in the ATA Carnet application form and upload the required documents for the shipment."
        },
        {
          "title": "Approval process",
          "description": "Your application will be reviewed and approved within two business days of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your documents."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members and non-members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements to apply for this service:",
        "list": [{
          "title": "VAT Registration Certificate"
        },
        {
          "title": "Trade License"
        }, {
          "title": "Company account Details-under Bank letterhead"
        }, {
          "title": "Scanned copy of the ATA Carnet"
        }, {
          "title": "Note: Refund of the Security Deposit will be initiated after submission of the original ATA Carnet."
        }]
      },
      "serviceFees": [
        {
          "title": "Services Fees",
          "list": [
            "Member - No refund of processing fees",
            "Non-member - No refund of processing fees"
          ]
        },
        {
          "title": "Security Deposit",
          "list": [
            "The security deposit fees are based on the total value of goods and customs duties (ATA Carnet Security Rate Chart) in the visiting countries. They will be refunded after the Carnet is properly discharged."
          ]
        }
      ],
      "resources": [
        {
          "title": "Refund of ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/refund-of-ata-carnet"
        },
        {
          "title": "Issuance of ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
        }
      ]
    },
    {
      "SRType": "ATA Carnet||NOC Letter Request",
      "serviceNameForList": "SR_ATA_CARNET_NOC",
      "id": "ata-carnet-noc-letter",
      "sequence": 14,
      "serviceName": "NOC Letter Request",
      "serviceNameKey": "NOC_LETTER_CARNET",
      "organization": "ATA Carnet",
      "parentServiceKey": "ATA_CARNET",
      "accessFlagKey": "DC ATA Carnet Flag",
      "serviceDetail": {
        "description": "Request to issue No Objection Certificate requested by the local Customs.",
        "processingTime": "1 business day",
        "feesNote": "AED 100"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click \"Start Service\" to log in or create an account on the Dubai Chambers services portal."
        },
        {
          "title": "Submit your application",
          "description": "Fill in the ATA Carnet application form and upload the required documents for the shipment."
        },
        {
          "title": "Approval process",
          "description": "Your application will be reviewed and approved within two business days of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your documents."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members and non-members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Please note, if 'Carnet Type' is Local, only the first page of the form is required. Kindly make sure of the availability of below pre-requisites to avail the service.",
        "list": [{
          "title": "Original Carnet Copy"
        },
        {
          "title": "Request Letter"
        }]
      },
      "serviceFees": [
        {
          "title": "Services Fees",
          "list": [
            "AED 100"
          ]
        }
      ],
      "resources": [
        {
          "title": "Refund of ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/refund-of-ata-carnet"
        },
        {
          "title": "Issuance of ATA Carnet – Service Page",
          "url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
        }
      ]
    },
    {
      "SRType": "Mediation Services||Mediation",
      "serviceNameForList": "SR_MEDIATION",
      "id": "mediation",
      "sequence": 23,
      "serviceName": "Mediation",
      "serviceNameKey": "MEDIATION",
      "organization": "Mediation Services",
      "parentServiceKey": "MEDIATION_SERVICES",
      "accessFlagKey": "DC Legal Services Flag",
      "PreText": "Request for Mediation to resolve commercial disputes amicably",
      "serviceDetail": {
        "description": "Resolve commercial disputes quickly and amicably with our Mediation service. Benefit from a confidential, cost-effective process that helps you avoid lengthy and expensive litigation. Our expert mediators assist in facilitating negotiations, helping you reach a mutually agreeable resolution with flexibility and ease. Mediation is the most effective alternative dispute resolution.",
        "processingTime": "6 days",
        "feesNote": "AED 500 to AED 1,000"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
        },
        {
          "title": "Submit your application",
          "description": "Follow the instructions to submit all required information and supporting documents related to the dispute."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, Dubai Chamber of Commerce contacts the concerned parties to reach a suitable settlement (as per the nature of the dispute)."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members and non-members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the requirements to apply for this service.",
        "list": [
          {
            "title": "Attach at least one supporting document such as an invoice, LPO, delivery note, bill of lading, or contract",
            "documents": [{
              "title": "Invoices"
            },
            { "title": "LPOs" },
            {
              "title": "Delivery Notes"
            },
            {
              "title": "Correspondences"
            },
            {
              "title": "Agreement/ Contract"
            },
            { "title": "Delivery Notes" },
            { "title": "Statement of Account" },
            { "title": "Quotation" },
            { "title": "Statement of Account" },
            { "title": "Letter of Credit" },
            { "title": "Bill of Lading" }]
          },
          {
            "title": "Other documents",
            "documents": [{
              "title": "Letter of Authorization/ Power of Attorney to lodge a complaint before Dubai Chamber (applicable only to the law firms)"
            }, {
              "title": "Complainant’s trade license (compulsory)"
            },
            { "title": "Document for appointment of Manager/ Representative (if applicable)" },
            { "title": "Copy of membership certificate (if applicable)" }
            ]
          }
        ]
      },
      "serviceFees": [
        {
          "title": "Mediation Registration Fee",
          "list": [
            "Members - AED 500 Non-members - AED 1,000",
          ]
        },
        {
          "title": "Mediation Administration Fee",
          "list": [
            "Members - 1% of the disputed amount, minimum AED 500, maximum AED 15,000",
            "Non-members – 2% of the disputed amount, minimum AED 1,000, maximum AED 20,000"
          ]
        },
        {
          "title": "Value Added Tax: 5%",
          "list": [
            "The above fees and tax are non-refundable and must be paid in advance to proceed with the mediation process.",
          ]
        },
        {
          "title": "The total service fee amount may vary depending on your specific requirements.",
        }
      ],
      "Sector": "Business",
      "serviceType": "Sub-service - Informational",
      "resources": [
        {
          "title": "Mediation – Service Page",
          "url": "https://www.dubaichambers.com/en/mediation"
        }
      ]
    },
    {
      "SRType": "Information Services||Information Services",
      "serviceNameForList": "SR_INFORMATION_SERVICE",
      "id": 'information-service',
      "sequence": 27,
      "serviceName": "Information and Certificates Services",
      "serviceNameKey": "INFORMATION_SERVICES",
      "organization": "Information Services",
      "parentServiceKey": "INFORMATION_AND_CERTIFICATES_SERVICES",
      "accessFlagKey": "DC Information Services Flag",
      "PreText": "A service available for requesting essential documents, such as establishment details and “To Whom It May Concern” certificates.",//"This service provides to whom it may concern letters and certification of recommendation and identification and company profile channels.",
      "serviceDetail": {
        "description": "Verify and authenticate the authorised signatory and related documents, correspondence, and contracts, ensuring they are accepted by the relevant authorities. This service helps our members by simplifying procedures and enhancing the credibility of their official documents.",
        "processingTime": "Two hours",
        "feesNote": "AED 210"
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
        },
        {
          "title": "Submit your application",
          "description": "Submit the requested certificate or letter through the website and provide all required information."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your documents."
        }
      ],
      "Beneficiaries": [
        {
          "title": "Beneficiaries",
          "description": "Dubai Chamber of Commerce members can apply for this service."
        }
      ],
      "serviceRequirements": {
        "title": "Here are the document requirements to apply for this service:",
        "list": [
          {
            "title": "A request letter from the company, signed and stamped by the authorised signatory at Dubai Chambers",
          }
        ]
      },
      "serviceFees": [
        {
          "title": "Letters and certificates fees",
          "list": [
            "To whom it may concern letter: AED 210"
          ]
        }, {
          "title": " Company profile fees",
          "list": [
            "Company Profile: AED 52.50"
          ]
        },

      ],
      "resources": [
        {
          "title": "Letters and Certificates – Service Page",
          "url": "https://www.dubaichambers.com/en/letters-and-certificates"
        },
        {
          "title": "Company Profile – Related Service",
          "url": "https://www.dubaichambers.com/en/company-profile"
        }
      ]
    },
    {
      "SRType": "Mystery Shopper Membership||Mystery Shopper Membership",
      "serviceNameForList": "SR_MYSTERY_SHOPPER_MEMBERSHIP",
      "id": 'mystery-shopper',
      "sequence": 27,
      "serviceName": "Mystery Shopper Membership",
      "organization": "Mystery Shopper Membership",
      "parentServiceKey": "SERVICE_EXCELLENCE_PROGRAMME",      
      "serviceNameKey": "MYSTERY_SHOPPER_MEMBERSHIP",
      "PreText": "",
      "serviceDetail": {
        "description": "",
        "processingTime": "",
        "feesNote": "",
        "otherDetail": {
          "greeting": "Dear Value Member,",
          "intro": "Below are the membership packages you can opt in while submitting the application:",
          "titile": "Packages:",
          "list": [{
            "title": "<b>Package 1:</b> Includes 2 visits per branch per quarter."
          },
          { "title": "<b>Package 2:</b> Includes 3 visits per branch per quarter." },
          { "title": "<b>Package 3:</b> Includes 2 virtual assessments per channel per quarter." },
          { "title": "<b>Package 4: </b>Includes 1 visit per branch per quarter." },
          { "title": "<b>Package 5: </b>Includes 1 virtual assessment per channel per quarter." },
          { "title": "<b>Branding Kit</b>: Per brand (not per branch)." }
          ]
        }
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
        },
        {
          "title": "Submit your application",
          "description": "Submit the requested certificate or letter through the website and provide all required information."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your documents."
        }
      ],
      "serviceFees": [
        {
          "title": "*Fees might vary based on application details.",
        }
      ]
    },
    {
      "SRType": "MRM Awards||MRM Awards",
      "serviceNameForList": "SR_MRM_AWARDS",
      "id": 'mrm-award',
      "sequence": 27,
      "serviceName": "MRM Awards",
      "organization": "MRM Awards",
      "parentServiceKey": "MRM_AWARDS",      
      "serviceNameKey": "MRM_APPLICATION",
      "PreText": "",
      "serviceDetail": {
        "description": "",
        "processingTime": "",
        "feesNote": "",
        "otherDetail": {
          "greeting": "Dear Value Member,",
          "intro": "Applicants will choose which Award Category they want to be officially apply to.",
        }
      },
      "serviceProcedure": [
        {
          "title": "Access services portal",
          "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
        },
        {
          "title": "Submit your application",
          "description": "Submit the requested certificate or letter through the website and provide all required information."
        },
        {
          "title": "Approval process",
          "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
        },
        {
          "title": "Payment and confirmation",
          "description": "After paying the fees, you will be prompted to download your documents."
        }
      ],

      "serviceFees": [
        { "title": "Fees might vary based on application details." },
        {
          "title": "Application traning fees:",
          "list": [
            "DC Member: 2500 AED per delegates",
            "Non Member: 3000 AED per delegates"
          ]
        }, {
          "title": "Submission fees:",
          "list": [
            "DC Member: 3000 AED",
            "Non Member: 3500 AED"
          ]
        },
        {
          "title": "*Note: VAT fees will be applicable."
        },

      ]
    },
    // {
    //   "SRType": "MRM Awards||MRM Training Workshop",
    //   "serviceNameForList": "SR_MRM_TRAINING_WORKSHOP",
    //   "id": 'mrm-training-workshop',
    //   "sequence": 27,
    //   "serviceName": "MRM Training Workshop",
    //   "organization": "MRM Awards",
    //   "parentServiceKey": "MRM_AWARDS",      
    //   "serviceNameKey": "MRM_TRAINING_WORKSHOP",
    //   "PreText": "",
    //   "serviceDetail": {
    //     "description": "",
    //     "processingTime": "",
    //     "feesNote": "",
    //     "otherDetail": {
    //       "greeting": "Dear Value Member,",
    //       "intro": "Applicants will choose which Award Category they want to be officially apply to.",
    //     }
    //   },
    //   "serviceProcedure": [
    //     {
    //       "title": "Access services portal",
    //       "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
    //     },
    //     {
    //       "title": "Submit your application",
    //       "description": "Submit the requested certificate or letter through the website and provide all required information."
    //     },
    //     {
    //       "title": "Approval process",
    //       "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
    //     },
    //     {
    //       "title": "Payment and confirmation",
    //       "description": "After paying the fees, you will be prompted to download your documents."
    //     }
    //   ],
    //   "serviceFees": [
    //     { "title": "Fees might vary based on application details." },
    //     {
    //       "title": "Application traning fees:",
    //       "list": [
    //         "DC Member: AED 2500 per delegates",
    //         "Non Member: AED 3000 per delegates"
    //       ]
    //     },
    //     {
    //       "title": "*Note: VAT fees will be applicable."
    //     }
    //   ]
    // },
    // {
    //   "SRType": "Business Group & Councils||Business Group & Councils",
    //   "serviceNameForList": "MENU_BUSINESS_GROUP",
    //   "id": 'information-service',
    //   "sequence": 27,
    //   "serviceName": "Business Group & Councils",
    //   "organization": "Business Group & Councils",
    //   "PreText": "This service provides to whom it may concern letters and certification of recommendation and identification and company profile channels.",
    //   "serviceDetail": {
    //     "description": "Verify and authenticate the authorised signatory and related documents, correspondence, and contracts, ensuring they are accepted by the relevant authorities. This service helps our members by simplifying procedures and enhancing the credibility of their official documents.",
    //     "processingTime": "Two hours",
    //     "feesNote": "AED 210"
    //   },
    //   "serviceProcedure": [
    //     {
    //       "title": "Access services portal",
    //       "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
    //     },
    //     {
    //       "title": "Submit your application",
    //       "description": "Submit the requested certificate or letter through the website and provide all required information."
    //     },
    //     {
    //       "title": "Approval process",
    //       "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
    //     },
    //     {
    //       "title": "Payment and confirmation",
    //       "description": "After paying the fees, you will be prompted to download your documents."
    //     }
    //   ],
    //   "Beneficiaries": [
    //     {
    //       "title": "Beneficiaries",
    //       "description": "Dubai Chamber of Commerce members can apply for this service."
    //     }
    //   ],
    //   "serviceRequirements": {
    //     "title": "Here are the document requirements to apply for this service:",
    //     "list": [
    //       {
    //         "title": "A request letter from the company, signed and stamped by the authorised signatory at Dubai Chambers",
    //       }
    //     ]
    //   },
    //   "serviceFees": [
    //     {
    //       "title": "Letters and certificates fees",
    //       "list": [
    //         "To whom it may concern letter: AED 210"
    //       ]
    //     }, {
    //       "title": " Company profile fees",
    //       "list": [
    //         "Company Profile: AED 52.50"
    //       ]
    //     },

    //   ],
    //   "resources": [
    //     {
    //       "title": "Letters and Certificates – Service Page",
    //       "url": "https://www.dubaichambers.com/en/letters-and-certificates"
    //     },
    //     {
    //       "title": "Company Profile – Related Service",
    //       "url": "https://www.dubaichambers.com/en/company-profile"
    //     }
    //   ]
    // },
    // {
    //   "SRType": "Sustainability||Sustainability",
    //   "serviceNameForList": "MENU_SUSTAINABILITY",
    //   "id": 'information-service',
    //   "sequence": 27,
    //   "serviceName": "Sustainability",
    //   "organization": "Sustainability",
    //   "PreText": "This service provides to whom it may concern letters and certification of recommendation and identification and company profile channels.",
    //   "serviceDetail": {
    //     "description": "Verify and authenticate the authorised signatory and related documents, correspondence, and contracts, ensuring they are accepted by the relevant authorities. This service helps our members by simplifying procedures and enhancing the credibility of their official documents.",
    //     "processingTime": "Two hours",
    //     "feesNote": "AED 210"
    //   },
    //   "serviceProcedure": [
    //     {
    //       "title": "Access services portal",
    //       "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
    //     },
    //     {
    //       "title": "Submit your application",
    //       "description": "Submit the requested certificate or letter through the website and provide all required information."
    //     },
    //     {
    //       "title": "Approval process",
    //       "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
    //     },
    //     {
    //       "title": "Payment and confirmation",
    //       "description": "After paying the fees, you will be prompted to download your documents."
    //     }
    //   ],
    //   "Beneficiaries": [
    //     {
    //       "title": "Beneficiaries",
    //       "description": "Dubai Chamber of Commerce members can apply for this service."
    //     }
    //   ],
    //   "serviceRequirements": {
    //     "title": "Here are the document requirements to apply for this service:",
    //     "list": [
    //       {
    //         "title": "A request letter from the company, signed and stamped by the authorised signatory at Dubai Chambers",
    //       }
    //     ]
    //   },
    //   "serviceFees": [
    //     {
    //       "title": "Letters and certificates fees",
    //       "list": [
    //         "To whom it may concern letter: AED 210"
    //       ]
    //     }, {
    //       "title": " Company profile fees",
    //       "list": [
    //         "Company Profile: AED 52.50"
    //       ]
    //     },

    //   ],
    //   "resources": [
    //     {
    //       "title": "Letters and Certificates – Service Page",
    //       "url": "https://www.dubaichambers.com/en/letters-and-certificates"
    //     },
    //     {
    //       "title": "Company Profile – Related Service",
    //       "url": "https://www.dubaichambers.com/en/company-profile"
    //     }
    //   ]
    // },

    // {
    //   "serviceId": "company-profile",
    //   "serviceName": "Company Profile",
    //   "organization": "Dubai Chambers",
    //   "url": "https://www.dubaichambers.com/en/company-profile",
    //   "serviceDetail": {
    //     "description": "This service allows you to apply for an official Company Profile from Dubai Chamber of Commerce. The profile includes key economic and registration information about your company, helping build trust with clients, partners and regulators and supporting business growth.",
    //     "processingTime": "Two hours",
    //     "feesNote": "Company Profile fee is AED 52.50."
    //   },
    //   "serviceProcedure": [
    //     {
    //       "title": "Access services portal",
    //       "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
    //     },
    //     {
    //       "title": "Submit your application",
    //       "description": "Follow the instructions to submit the Company Profile request through the website."
    //     },
    //     {
    //       "title": "Approval process",
    //       "description": "Your request will be reviewed and approved within two hours of submission if all requirements are met."
    //     },
    //     {
    //       "title": "Payment and confirmation",
    //       "description": "After paying the fees, you will be prompted to download your Company Profile document."
    //     }
    //   ],
    //   "Beneficiaries": [
    //     {
    //       "title": "Beneficiaries",
    //       "description": "Dubai Chamber of Commerce members and non-members can apply for this service."
    //     }
    //   ],
    //   "serviceRequirements": {
    //     "title": "Here are the document requirements to apply for this service:",
    //     "list": [
    //       {
    //         "title": "Online submission",
    //         "description": "Submit the Company Profile application through the Dubai Chambers website."
    //       }
    //     ]
    //   },
    //   "serviceFees": [
    //     {
    //       "title": "Company Profile fees",
    //       "list": [
    //         "Company Profile: AED 52.50."
    //       ]
    //     }
    //   ],
    //   "additionalInformation": {
    //     "otherChannels": "Provided as part of Dubai Chambers’ Business Research and Information services; all requirements are submitted online and processed within two hours.",
    //     "contact": "WhatsApp: (+971) 800 242 6237; toll-free within UAE: 800 242 6237 (800 CHAMBER); enquiry email and chat support are available via the Dubai Chambers website.",
    //     "location": "Dubai Chambers online services portal."
    //   },
    //   "howToApply": [
    //     "Open the Company Profile service page on the Dubai Chambers website and click 'Start Service'.",
    //     "Log in or register and submit the Company Profile request through the website.",
    //     "Pay the service fee and download the issued Company Profile once your request has been approved."
    //   ],
    //   "resources": [
    //     {
    //       "title": "Company Profile – Service Page",
    //       "url": "https://www.dubaichambers.com/en/company-profile"
    //     },
    //     {
    //       "title": "Dubai Chambers Service Manual – Information Services",
    //       "url": "https://www.dubaichambers.com/documents/20119/0/Service_Manual_En%2B%281%29.pdf"
    //     },
    //     {
    //       "title": "Letters and Certificates – Related Service",
    //       "url": "https://www.dubaichambers.com/en/letters-and-certificates"
    //     }
    //   ],
    //   "SRType": "",
    //   "id": "",
    //   "sequence": null
    // }
  ]
};

// ids and sequence are statically defined per item above.
